(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["chestslot-product-copy"] && !Shopify.designMode) return;
  try {
    class ChestslotProductDescription extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const preview = this.querySelector('.cs-product-description__preview');
      const full = this.querySelector('.cs-product-description__full');
      const button = this.querySelector('.cs-product-description__toggle');
      if (!preview || !full || !button) return;
      this.initialized = true;
      preview.hidden = false;
      full.hidden = true;
      button.hidden = false;
      button.textContent = this.dataset.more;
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        preview.hidden = !expanded;
        full.hidden = expanded;
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded ? this.dataset.more : this.dataset.less;
      });
    }
  }
  if (!customElements.get('chestslot-product-description')) {
    customElements.define('chestslot-product-description', ChestslotProductDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["chestslot-size-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.cs-size-link');
    if (!link) return;
    const guide = document.getElementById(link.hash.slice(1));
    if (!guide) return;
    event.preventDefault();
    guide.open = true;
    guide.scrollIntoView({block: 'center'});
    guide.querySelector('summary')?.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
